import {
  Box,
  DropdownOptions,
  FormProvider,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  TooltipPopup,
} from "dash-ui";

import ArchiveUserModal from "../components/ArchiveUserModal/ArchiveUserModal";
import ManagementPageHeader from "../components/ManagementPageHeader/ManagementPageHeader";
import ManagementPageTable from "../components/ManagementPageTable/ManagementPageTable";
import SaveUserModal from "../components/SaveUserModal/SaveUserModal";
import { CreateUserFormFieldsList } from "../constants/constants";
import DeleteCmsUserModal from "../components/DeleteCmsUserModal/DeleteCmsUserModal";

const ManagementUsersPage = () => (
  <PaginationProvider>
    <SortProvider>
      <SearchProvider>
        <ModalProvider>
          <FormProvider fieldsList={CreateUserFormFieldsList}>
            <Box w="100%">
              <DropdownOptions />
              <TooltipPopup />
              <ArchiveUserModal />
              <ManagementPageHeader />
              <ManagementPageTable />
              <SaveUserModal />
              <DeleteCmsUserModal />
            </Box>
          </FormProvider>
        </ModalProvider>
      </SearchProvider>
    </SortProvider>
  </PaginationProvider>
);

export default ManagementUsersPage;
